import { api } from '@/api'
import type { AdminItem } from '@/api/typings/admins.typing'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface CreateAdminPayload {
  full_name: string
  email: string
  password: string
  password_confirmation: string
  roles: number // role ID
  status: 'ACTIVATE' | 'DEACTIVATE'
}

export function createAdminAction(payload: CreateAdminPayload): Promise<ApiResponse<AdminItem>> {
  return api.post<ApiResponse<AdminItem>>('/admins', { ...payload })
}
